// extracted by mini-css-extract-plugin
export var avatar = "_k9-3";
export var avatarContainer = "_k9-2";
export var avatarSpacer = "_k9-5";
export var avatarSpacerContainer = "_k9-4";
export var avatarStackContainer = "_k9-1";
export var bubble = "_k9-0";
export var remainderBubble = "_k9-6";